import { atom, createStore } from "jotai";
import { atomWithStorage } from "jotai/utils";
import type {
  OnboardingModalFormData,
  OnboardingModalStep,
  OrgType,
} from "../types";

export const ONBOARDING_STEP_KEY = "onboarding_modal_step";
export const ONBOARDING_FORM_KEY = "onboarding_modal_form_data";

export const onboardingModalStore = createStore();

export const initialFormData: OnboardingModalFormData = {
  orgType: null,
  currentTools: [],
  teamSize: null,
  endUserSize: null,
  improvements: [],
  integrations: {},
  referralSource: null,
  otherTexts: {},
};

export const currentStepAtom = atomWithStorage<OnboardingModalStep>(
  ONBOARDING_STEP_KEY,
  0,
);

export const formDataAtom = atomWithStorage<OnboardingModalFormData>(
  ONBOARDING_FORM_KEY,
  initialFormData,
);

/** Read/write atom for orgType that resets downstream fields on change */
export const orgTypeAtom = atom(
  (get) => get(formDataAtom).orgType,
  (get, set, value: OrgType) => {
    const prev = get(formDataAtom);
    if (prev.orgType === value) return;
    set(formDataAtom, {
      ...initialFormData,
      orgType: value,
    });
  },
);

/** Write-only atom for partial form updates */
export const updateFieldAtom = atom(
  null,
  (get, set, update: Partial<OnboardingModalFormData>) => {
    set(formDataAtom, { ...get(formDataAtom), ...update });
  },
);

/** Tracks which "other" input fields are in error state (keyed by otherTexts key) */
export const otherErrorsAtom = atom<Record<string, boolean>>({});
